const theme = {
	images: {
		logo: "https://d3m49n4oy99qs7.cloudfront.net/web/600adc0a16d44_infocdn__logo.png",
		isotipo: "https://d3m49n4oy99qs7.cloudfront.net/web/600adc0a17230_infocdn__icono.png",
		favicon: "https://d3m49n4oy99qs7.cloudfront.net/web/600ae96b348b9_infocdn__favicon.ico",
		icono: "https://d3m49n4oy99qs7.cloudfront.net/web/600adc0a17230_infocdn__icono.png",
	},
	fontFamily: "Lato, system, -apple-system, sans-serif",
	colors: {
		primaryColor: "#00E6B8",
		primaryHoverColor: "rgba(0,230,184,0.2)",
		primaryDarkColor: "#01d2a8",
		secondaryColor: "#002180",
		secondaryOpacityColor: "rgba(0,33,128,0.2)",
		secondaryHoverColor: "#021b65",
		textColor: "#3A4145",
		textSecondaryColor: "#808485",
		textInverseColor: "#a7a7a7",
		backgroundColor: "#fff",
		backgroundModalColor: "rgba(0, 0, 0, 0.5)",
		backgroundMenuColor: "#3A4145",
		linkColor: "#002180", // == secondaryColor
		linkHoverColor: "#021b65", // == secondaryHoverColor
		backgroundColorAternative: "#FAFAFA",
		borderColor: "#E9E9E9",
		favoriteColor: "#ff6767",
		successColor: "#69AD6C",
		errorColor: "#F24E1E",
		warningColor: "#fff3cd",
    placeholderTextColor: "#cccccc",
	},
	breakPoints: {
		xs: "576px",
		sm: "576px",
		md: "768px",
		lg: "992px",
		xl: "1200px",
		xxl: "1600px",
	},
	headerHeight: 64,
	spacing: {
		xsSpacing: 4,
		smSpacing: 8,
		mdSpacing: 12,
		lgSpacing: 16,
		xlSpacing: 24,
		xxlSpacing: 32,
	},
	fontSizes: {
		baseFontSize: "16px",
		baseLineHeight: 1.5,

		lgFontSize: "18px",
		smFontSize: "14px",
		xsFontSize: "12px",

		xlTitle: "32px",
		xlLineHeight: "40px",
		lgTitle: "28px",
		lgLineHeight: "36px",
		mdTitle: "24px",
		mdLineHeight: "32px",
		smTitle: "20px",
		smLineHeight: "28px",
		xsTitle: "18px",
		xsLineHeight: "24px",
	},
};

module.exports = theme;
